import { PricingPageParams } from "~/solidJs/shared/models/pageParams";
import type { StyledSelect } from "~/solidJs/shared/ui/molecules/Select";

export interface PaymentMethod extends StyledSelect.SelectClosedItem {
	value: string;
	label: string;
	id: string;
	last4: string;
	brand: string;
	is_default: boolean;
	system: string;
}

export interface PaymentCurrency extends StyledSelect.SelectClosedItem {
	value: string;
	label: string;
}

// Currency constants for PricingPage
export const UsdCurrencyPricing: PaymentCurrency = {
	value: PricingPageParams.PaymentCurrency.USD,
	label: "$ USD"
} as const satisfies PaymentCurrency;

export const RubCurrencyPricing: PaymentCurrency = {
	value: PricingPageParams.PaymentCurrency.RUB,
	label: "RUB ₽"
} as const satisfies PaymentCurrency;

export const PRICING_PAGE_CURRENCIES = [UsdCurrencyPricing, RubCurrencyPricing];

export const ADD_NEW_PAYMENT_METHOD_ID = "add-new";
